import { EnvironmentSite } from '@impact/environments';
import { MapsLocation } from './maps.component';

export const filterLocationsByShowOn = (location: MapsLocation, site: EnvironmentSite): boolean => {
    if (site === 'Bjarne Nielsen')
        return location.showOnBNDK;

    if (site === 'Bilernes Hus')
        return location.showOnBilernesHusDk;

    if (site === 'Leasing')
        return location.showOnLeasingDk;

    if (site === 'Motorpoint')
        return location.showOnMotorpointDk;

    return true;
}
